import * as React from "react"
import RootStyles from "./src/components/root-styles"

export const wrapRootElement = ({ element }) => (
  <React.StrictMode>
    <RootStyles />
    {element}
  </React.StrictMode>
)
